import React, { lazy } from "react";
import { Redirect } from "react-router-dom";

const Home = lazy(() => import("../pages/Home/Home"));
const IconBoxicons = lazy(
  () => import("../components/Common/Icons/IconBoxicons"),
);
const IconFontawesome = lazy(
  () => import("../components/Common/Icons/IconFontawesome"),
);
const WalletPage = lazy(() => import("../pages/Deposits/WalletPage"));
const Register = lazy(() => import("../pages/Register/Register"));
const Login = lazy(() => import("../pages/Login/Login"));
const Promotions = lazy(() => import("../pages/Promotions/Promotions"));
const PromotionDetails = lazy(
  () => import("../pages/Promotions/PromotionDetails"),
);
const StaticPage = lazy(() => import("../pages/StaticPages/StaticPage"));
const ResponsibleGaming = lazy(
  () => import("../pages/ResponsibleGaming/ResponsibleGaming"),
);
const ChangePin = lazy(() => import("../pages/ChangePin/ChangePin"));
const AllSports = lazy(() => import("../pages/AllSports/AllSports"));
const TransactionHistory = lazy(
  () => import("../pages/TransactionHistory/TransactionHistory"),
);
const ForgotPin = lazy(() => import("../pages/ForgotPin/ForgotPin"));
const Profile = lazy(() => import("../pages/Profile/Profile"));
const DeleteAccount = lazy(() => import("../pages/DeleteAccount/DeleteAccount"));
const VirtualLeague = lazy(
  () => import("../pages/VirtualLeague/VirtualLeague"),
);
const HotGames = lazy(() => import("../pages/HotGames/HotGames"));
const Jackpot = lazy(() => import("../pages/Jackpot/Jackpot"));
const RunningJackpot = lazy(() => import("../pages/Jackpot/RunningJackpot"));
const UpcomingJackpot = lazy(() => import("../pages/Jackpot/UpcomingJackpot"));
const SettledBets = lazy(() => import("../pages/MyBets/SettledBets"));
const SportsDetails = lazy(
  () => import("../pages/AllSports/SportsDetails/SportsDetails"),
);
const SportsCustomDate = lazy(() => import("../pages/CustomDate/CustomDate"));
const LeagueDetails = lazy(
  () => import("../pages/LeagueDetails/LeagueDetails"),
);
const SportsDetailsAllCountries = lazy(
  () => import("../pages/AllSports/SportsDetails/SportsDetailsAllCountries"),
);
const SportsDetailsAllLeagues = lazy(
  () => import("../pages/AllSports/SportsDetails/SportsDetailsAllLeagues"),
);
const Casinos = lazy(() => import("../pages/Casinos/Casinos"));
const OpenBets = lazy(() => import("../pages/MyBets/OpenBets"));
const FixtureDetails = lazy(() => import("../pages/Home/FixtureDetails"));
const FixtureLiveDetails = lazy(
  () => import("../pages/Home/FixtureLiveDetails"),
);
const MyBets = lazy(() => import("../pages/MyBets/MyBets"));
const CompleteJackpot = lazy(() => import("../pages/Jackpot/CompleteJackpot"));
const CommingSoon = lazy(() => import("../components/Layouts/CommingSoon"));
const Games = lazy(() => import("../pages/Games/Games"));
const GamesHub = lazy(() => import("../pages/GamesHub/GamesHub"));
const Spribe = lazy(() => import("../pages/Spribe/Spribe"));
const BonusAwarded = lazy(() => import("../pages/BonusAwarded/BonusAwarded"));
const RefereAFriend = lazy(
  () => import("../pages/RefereAFriend/RefereAFriend"),
);
const Aviator = lazy(() => import("../pages/Aviator/Aviator"));
const Bigwins = lazy(() => import("../pages/Bigwins/Bigwins"));
const BigBooms = lazy(() => import("../pages/BigBooms/BigBooms"));
const Slot = lazy(() => import("../pages/Slot/Slot"));
const ProviderGames = lazy(() => import("../pages/Bigwins/ProviderGames"));
const PaymentSuccess = lazy(
  () => import("../components/Common/PaymentSuccess"),
);
const PaymentError = lazy(() => import("../components/Common/PaymentError"));
const PaymentVerify = lazy(() => import("../components/Common/PaymentVerify"));

const publicRoutes = [
  { path: "/", exact: true, component: () => <Redirect to="/sports" /> },
  {
    path: "/Responsible-Gaming",
    component: ResponsibleGaming,
  },
  {
    path: "/Betting-Rules",
    component: StaticPage,
  },
  {
    path: "/Privacy-Policy",
    component: StaticPage,
  },
  {
    path: "/Cookies-Policy",
    component: StaticPage,
  },
  {
    path: "/Terms-and-Conditions",
    component: StaticPage,
  },
  {
    path: "/FAQ's",
    component: StaticPage,
  },

  {
    path: "/Contact-us",
    component: StaticPage,
  },
  {
    path: "/casinos",
    component: Casinos,
  },
  {
    path: "/comming-soon",
    component: CommingSoon,
  },

  { path: "/sports", component: Home },
  // The combined deposit/withdrawal page lives at /payment now — keep both
  // old paths alive as redirects for any existing links/bookmarks.
  { path: "/withdrawals", component: () => <Redirect to="/payment?tab=withdraw" /> },
  { path: "/deposits", component: () => <Redirect to="/payment?tab=deposit" /> },
  { path: "/payment", component: WalletPage },
  { path: "/icons-boxicons", component: IconBoxicons },
  { path: "/icons-fontawesome", component: IconFontawesome },
  { path: "/register", component: Register },
  { path: "/login", component: Login },
  { path: "/transaction-history", component: TransactionHistory },
  { path: "/bonuses-awarded", component: BonusAwarded },
  { path: "/refer-a-friend", component: RefereAFriend },
  { path: "/change-pin", component: ChangePin },
  { path: "/AllSports", component: AllSports },
  { path: "/promotions", component: Promotions },
  { path: "/promotion-details/item", component: PromotionDetails },
  { path: "/forgot-pin", component: ForgotPin },
  { path: "/virtual-league", component: VirtualLeague },
  { path: "/hot-games", component: HotGames },
  { path: "/jackpot", component: Jackpot },
  { path: "/jackpot-running/:id", component: RunningJackpot },
  { path: "/jackpot-complete/:id", component: CompleteJackpot },
  { path: "/jackpot-upcoming", component: UpcomingJackpot },
  { path: "/league-details", component: LeagueDetails },
  { path: "/countries", component: SportsDetailsAllCountries },
  { path: "/all-leagues", component: SportsDetailsAllLeagues },
  { path: "/Games", component: GamesHub },
  { path: "/Spribe", component: Spribe },
  { path: "/Bigwins", component: Bigwins },
  { path: "/slot", component: Slot },

  { path: "/booming", component: BigBooms },
  { path: "/provider/:providerId", component: ProviderGames },
  { path: "/aviator", component: Aviator },
  {
    path: "/fixture-details/show",
    component: FixtureDetails,
  },
  {
    path: "/fixture-details/live/show",
    component: FixtureLiveDetails,
  },
  { path: "/sports-details", component: SportsDetails },
  { path: "/sport", component: SportsCustomDate },
  { path: "/MyBets", component: MyBets },
  { path: "/payment-success", component: PaymentSuccess },
  { path: "/payment-error", component: PaymentError },
  { path: "/payment-verify", component: PaymentVerify },
];

const authProtectedRoutes = [
  { path: "/profile", component: Profile },
  { path: "/delete-account", component: DeleteAccount },
];

export { authProtectedRoutes, publicRoutes };
